define([
    'jquery',
    'popper.js',
    'bootstrap',
    'core/csrf-safe-xhr',
    'core/error-manager',
    'core/browser-check',
    'core/navigation'
], function() {
    console.log('System initialized.');
});
